function normalizeSourceText(text) {
  return String(text || "").replace(/\s+/g, " ").trim();
}

const ORAL_FILLERS_HE = [
  "אוקיי",
  "אוקי",
  "בסדר",
  "נו",
  "אז",
  "טוב",
  "כן",
  "יאללה",
  "נראהלי",
  "נראה",
  "כאילו",
];

const ORAL_FILLERS_EN = [
  "okay",
  "ok",
  "well",
  "so",
  "hmm",
  "um",
  "uh",
  "yeah",
  "yes",
  "hi",
  "hey",
];

const ORAL_FILLERS_ES = ["bueno", "ok", "vale", "pues", "eh", "bueno,", "ok,"];

function normalizeFillerToken(token, lang) {
  let t = String(token || "")
    .replace(/^["'`׳״]+|["'`׳״,:.!?]+$/g, "")
    .trim();
  if (lang === "en" || lang === "es") t = t.toLowerCase();
  return t;
}

/** מסיר מילות פתיחה דיבוריות (אוקיי, okay…) כדי שהמראה אחרי אינטייק תישאר נקייה. */
export function stripLeadingOralFillers(text, lang = "he") {
  const safeLang = lang === "en" ? "en" : lang === "es" ? "es" : "he";
  const fillers =
    safeLang === "en" ? ORAL_FILLERS_EN : safeLang === "es" ? ORAL_FILLERS_ES : ORAL_FILLERS_HE;
  const fillerSet = new Set(fillers);
  const normalized = normalizeSourceText(text);
  if (!normalized) return "";
  const tokens = normalized.split(/\s+/).filter(Boolean);
  while (tokens.length) {
    const first = normalizeFillerToken(tokens[0], safeLang);
    if (fillerSet.has(first)) tokens.shift();
    else break;
  }
  return tokens.join(" ").trim();
}

function trimFragmentEdges(text) {
  return String(text || "")
    .replace(/^[\s"'.,!?;:()[\]{}-]+|[\s"'.,!?;:()[\]{}-]+$/g, "")
    .trim();
}

export function extractExactUserFragment(
  text,
  {
    minWords = 4,
    maxWords = 8,
    minChars = 20,
    preferStart = false,
  } = {}
) {
  const normalized = trimFragmentEdges(normalizeSourceText(text));
  if (!normalized || normalized.length < minChars) return "";

  const tokens = normalized.split(/\s+/).filter(Boolean);
  if (!tokens.length) return "";
  if (tokens.length <= maxWords) return normalized;

  const sliceSize = Math.max(minWords, Math.min(maxWords, preferStart ? maxWords : 6));
  const start = preferStart
    ? 0
    : Math.max(
        0,
        Math.min(tokens.length - sliceSize, Math.floor(tokens.length / 2) - Math.floor(sliceSize / 2))
      );

  return trimFragmentEdges(tokens.slice(start, start + sliceSize).join(" "));
}

export function extractFirstMeaningfulUserFragment(
  text,
  {
    minWords = 4,
    maxWords = 8,
    minChars = 20,
  } = {}
) {
  return extractExactUserFragment(text, {
    minWords,
    maxWords,
    minChars,
    preferStart: true,
  });
}
